import React, { useEffect, useState } from 'react';
import { useSearchParams, useNavigate, Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { authService } from '../services/authService';
import PaperboyWordmark from '../components/PaperboyWordmark';
import './AuthPages.css';
import './GoogleCallbackPage.css';

const MagicLinkVerifyPage = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { loginWithTokens } = useAuth();
  const [error, setError] = useState(null);

  useEffect(() => {
    const token = searchParams.get('token');
    if (!token) {
      setError('Missing magic link token');
      return;
    }

    let cancelled = false;
    authService
      .verifyMagicLink(token)
      .then((data) => {
        if (cancelled) return;
        if (data?.access_token && data?.refresh_token) {
          return loginWithTokens(data.access_token, data.refresh_token).then(() => {
            navigate('/feed', { replace: true });
          });
        }
        setError('Magic link verification did not return tokens');
      })
      .catch((err) => {
        if (cancelled) return;
        const detail = err?.response?.data?.detail;
        setError(detail || err?.message || 'Magic link verification failed');
      });

    return () => {
      cancelled = true;
    };
  }, [searchParams, loginWithTokens, navigate]);

  if (error) {
    return (
      <div className="oauth-callback">
        <div className="oauth-callback__inner">
          <PaperboyWordmark size={28} />
          <span className="mono-tag mono-tag--accent oauth-callback__eyebrow">
            <span className="oauth-callback__dot" aria-hidden="true" />
            Magic link · Failed
          </span>
          <p className="oauth-callback__copy">{error}</p>
          <Link to="/login" className="btn-ink">Back to Login</Link>
        </div>
      </div>
    );
  }

  return (
    <div className="oauth-callback" role="status" aria-live="polite">
      <div className="oauth-callback__inner">
        <PaperboyWordmark size={28} />
        <span className="mono-tag mono-tag--accent oauth-callback__eyebrow">
          <span className="oauth-callback__dot oauth-callback__dot--blink" aria-hidden="true" />
          Magic link · Verifying
        </span>
        <p className="oauth-callback__copy">
          Hold tight &mdash; we&rsquo;re unlocking your front page.
        </p>
      </div>
    </div>
  );
};

export default MagicLinkVerifyPage;
